import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import Field from '#client/components/Field';

import useAddress1Field from './useAddress1Field';

function Address1Field({ helperText, namePrefix, validation, ...delegated }) {
  const { error, field } = useAddress1Field({ namePrefix, validation });

  return (
    <Field
      {...field}
      error={error}
      helperText={helperText || error?.message}
      inputProps={{
        autoComplete: 'address-line1',
        'data-testid': 'address-line1'
      }}
      label={<FormattedMessage id="shopping.component.addressFieldset.address1Field.label" />}
      {...delegated}
    />
  );
}

Address1Field.propTypes = {
  helperText: PropTypes.string,
  namePrefix: PropTypes.string,
  validation: PropTypes.object
};

export default Address1Field;
